export default {
    namespaced : true,
    state      : () => ( {
        page               : 1,
        loading            : false,
        ymap               : null,
        mapId              : "initial",
        mapInitialized     : false,
        filter             : {},
        lastExecutedFilter             : {},
        frontFilter        : {
            metro    : "",
            district : ""
        },
        uniqueKey          : 1,
        list               : [],
        view               : "list",
        address            : "",
        selectedAddress    : null,
        singleAddressOnMap : null,
        sortData           : {
            type : "alphabet",
            asc  : true
        },
        sortTypes          : [
            {
                label : "По алфавиту",
                code  : "alphabet"
            }, {
                label : "По зарплате",
                code  : "salary"
            }
        ],
        citiesWithMetro    : []

    } ),
    mutations  : {
        setCitiesWithMetro( state, citiesList )
            {
                state.citiesWithMetro = citiesList;
            },
        setVacanciesType( state, type )
            {
                state.vacanciesType=type;
            },
        setVacanciesFilter( state, filter )
            {
                //загрузка в автоматическом режиме, но только если фильтр изменился
                if( JSON.stringify(filter) !== JSON.stringify(state.filter) )
                    {
                        state.filter=filter;
                        // this.dispatch("vacancies/loadVacancies");
                    }

            },
        setSortData( state, sortData )
            {
                state.sortData=sortData;
            },
        setVacancyViewMode( state, mode )
            {
                if( ["map", "list"].indexOf(mode) !== -1 )
                    {
                        state.view=mode;
                    }

            },
        setSelectedAddress( state, address )
            {
                state.singleAddressOnMap=address;
            },
        setVacancies( state, data )
            {
                state.list=data;
            },
        setMetroFilter( state, station )
            {
                if( state.frontFilter.metro !== station )
                    {
                        state.frontFilter.metro=station;
                    }
            },
        setDistrictFilter( state, district )
            {
                if( state.frontFilter.district !== district )
                    {
                        state.frontFilter.district=district;
                    }

            },
        setLoadingState( state, loading )
            {
                state.loading=loading;
            },
        setMapId( state )
            {
                let rawKey=state.filter.region + "_" + state.filter.city;
                rawKey    =rawKey
                    .replace(/\u0401/g, "YO")
                    .replace(/\u0419/g, "I")
                    .replace(/\u0426/g, "TS")
                    .replace(/\u0423/g, "U")
                    .replace(/\u041A/g, "K")
                    .replace(/\u0415/g, "E")
                    .replace(/\u041D/g, "N")
                    .replace(/\u0413/g, "G")
                    .replace(/\u0428/g, "SH")
                    .replace(/\u0429/g, "SCH")
                    .replace(/\u0417/g, "Z")
                    .replace(/\u0425/g, "H")
                    .replace(/\u042A/g, "")
                    .replace(/\u0451/g, "yo")
                    .replace(/\u0439/g, "i")
                    .replace(/\u0446/g, "ts")
                    .replace(/\u0443/g, "u")
                    .replace(/\u043A/g, "k")
                    .replace(/\u0435/g, "e")
                    .replace(/\u043D/g, "n")
                    .replace(/\u0433/g, "g")
                    .replace(/\u0448/g, "sh")
                    .replace(/\u0449/g, "sch")
                    .replace(/\u0437/g, "z")
                    .replace(/\u0445/g, "h")
                    .replace(/\u044A/g, "'")
                    .replace(/\u0424/g, "F")
                    .replace(/\u042B/g, "I")
                    .replace(/\u0412/g, "V")
                    .replace(/\u0410/g, "a")
                    .replace(/\u041F/g, "P")
                    .replace(/\u0420/g, "R")
                    .replace(/\u041E/g, "O")
                    .replace(/\u041B/g, "L")
                    .replace(/\u0414/g, "D")
                    .replace(/\u0416/g, "ZH")
                    .replace(/\u042D/g, "E")
                    .replace(/\u0444/g, "f")
                    .replace(/\u044B/g, "i")
                    .replace(/\u0432/g, "v")
                    .replace(/\u0430/g, "a")
                    .replace(/\u043F/g, "p")
                    .replace(/\u0440/g, "r")
                    .replace(/\u043E/g, "o")
                    .replace(/\u043B/g, "l")
                    .replace(/\u0434/g, "d")
                    .replace(/\u0436/g, "zh")
                    .replace(/\u044D/g, "e")
                    .replace(/\u042F/g, "Ya")
                    .replace(/\u0427/g, "CH")
                    .replace(/\u0421/g, "S")
                    .replace(/\u041C/g, "M")
                    .replace(/\u0418/g, "I")
                    .replace(/\u0422/g, "T")
                    .replace(/\u042C/g, "'")
                    .replace(/\u0411/g, "B")
                    .replace(/\u042E/g, "YU")
                    .replace(/\u044F/g, "ya")
                    .replace(/\u0447/g, "ch")
                    .replace(/\u0441/g, "s")
                    .replace(/\u043C/g, "m")
                    .replace(/\u0438/g, "i")
                    .replace(/\u0442/g, "t")
                    .replace(/\u044C/g, "'")
                    .replace(/\u0431/g, "b")
                    .replace(/\u044E/g, "yu");

                state.mapId=btoa(rawKey);
            },
        removeAddressFilter( state )
            {
                state.address           ="";
                state.singleAddressOnMap=null;
            },
        setLastExecutedFilter(state)
            {
                state.lastExecutedFilter = JSON.parse(JSON.stringify(state.filter));
            }
    },
    getters    : {
        cityHasMetro(state){
          return   state.citiesWithMetro.length && state.citiesWithMetro.indexOf(state.lastExecutedFilter.city)!==-1;
        },
        isLoading( state )
            {
                return state.loading;
            },
        vacancyFilter( state )
            {
                return state.filter;
            },
        list( state )
            {
                if( state.view === "map" && !state.address )
                    {
                        return [];
                    }
                let list=state.list.filter(address =>
                {
                    //фильтруем по адресам метро
                    if( state.frontFilter.metro )
                        {
                            if( !address.metro )
                                {
                                    return false;
                                }
                            if( address.metro.indexOf(state.frontFilter.metro) === -1 )
                                {
                                    return false;
                                }
                        }
                    if( state.frontFilter.district )
                        {
                            if( state.frontFilter.district !== address.district )
                                {
                                    return false;
                                }
                        }
                    //фильтрация по выбранной вакансии
                    if( state.address && state.address !== address.address )
                        {
                            return false;
                        }
                    return true;
                });
                list.sort(( addrA, addrB ) =>
                {
                    let valA, valB;
                    if( state.sortData.type === "alphabet" )
                        {
                            valA=addrA.vacancy.position.toLowerCase().replace(/[^а-яА-Я0-9A-Za-z]+/g, " ").trim();
                            valB=addrB.vacancy.position.toLowerCase().replace(/[^а-яА-Я0-9A-Za-z]+/g, " ").trim();
                            if( valA === valB )
                                {
                                    valA=addrA.address.toLowerCase().replace(/[^а-яА-Я0-9A-Za-z]+/g, " ").trim();
                                    valB=addrB.address.toLowerCase().replace(/[^а-яА-Я0-9A-Za-z]+/g, " ").trim();
                                }
                        }
                    else if( state.sortData.type === "salary" )
                        {
                            valA=addrA.vacancy.salary.to || addrA.vacancy.salary.from || "0";
                            valA= +valA.replace(" ", "");

                            valB=addrB.vacancy.salary.to || addrB.vacancy.salary.from || "0";
                            valB= +valB.replace(" ", "");
                        }


                    if( state.sortData.asc )
                        {
                            if( valA < valB )
                                {
                                    return -1;
                                }
                            else if( valA > valB )
                                {
                                    return 1;
                                }
                            else
                                {
                                    return 0;
                                }
                        }
                    else
                        {
                            if( valA < valB )
                                {
                                    return 1;
                                }
                            else if( valA > valB )
                                {
                                    return -1;
                                }
                            else
                                {
                                    return 0;
                                }

                        }
                });
                return list;
            },
        vacanciesCount( state )
            {
                return state.list.length;
            },
        metroStations( state )
            {
                let stations=[];
                state.list.forEach(address =>
                {
                    if( state.frontFilter.district && address.district !== state.frontFilter.district )
                        {
                            return;
                        }
                    if( address.metro && address.metro.length )
                        {
                            address.metro.forEach(station =>
                            {
                                if( stations.indexOf(station) === -1 )
                                    {
                                        stations.push(station.trim());
                                    }

                            });
                        }
                });
                if( !stations || stations.length === 0 )
                    {
                        return [];
                    }

                stations.sort();
                return stations;
            },
        districts( state )
            {
                let districts=[];
                state.list.forEach(address =>
                {
                    if( state.frontFilter.metro && address.metro.indexOf(state.frontFilter.metro) === -1 )
                        {
                            return;
                        }
                    address.district=address.district.trim();
                    if( address.district && districts.indexOf(address.district) === -1 )
                        {
                            districts.push(address.district);
                        }
                });
                if( !districts || districts.length === 0 )
                    {
                        return [];
                    }
                districts.sort();
                return districts;
            },
        mapList( state )
            {
                return state.list.filter(address =>
                {
                    return address.lat && address.lon;
                });
            },
        listByAddress( state )
            {

                let resultMap={};
                let result   =[];
                state.list.forEach(vacancyAddress =>
                {
                    if( state.singleAddressOnMap && vacancyAddress.address !== state.singleAddressOnMap )
                        {
                            return;
                        }
                    if( !vacancyAddress.lat || !vacancyAddress.lon )
                        {
                            return;
                        }

                    if( !resultMap[ vacancyAddress.address ] )
                        {
                            resultMap[ vacancyAddress.address ]={};
                            result.push(resultMap[ vacancyAddress.address ]);
                        }
                    resultMap[ vacancyAddress.address ][ vacancyAddress.id ]=vacancyAddress;
                });
                result.forEach(( vacList, i ) =>
                {
                    result[ i ]=Object.values(vacList);
                });
                return result;
            },
        addressFilter( state )
            {
                if( state.view === "list" )
                    {
                        return "";
                    }
                return state.address;
            },
        countForPagination( state, getters )
            {
                return getters.list.length;
            },
        isShopVacancy( state )
            {
                return state.filter.jobPlace && ( state.filter.jobPlace.toLowerCase() === "магазин" );
            },
        serializedFilter( state, getters )
            {
                let serialize=function( obj, prefix )
                    {
                        let str=[],
                            p;
                        for( p in obj )
                            {
                                if( obj.hasOwnProperty(p) )
                                    {
                                        let k=prefix ? prefix + "[" + p + "]" : p,
                                            v=obj[ p ];
                                        str.push(( v !== null && typeof v === "object" ) ?
                                            serialize(v, k) :
                                            encodeURIComponent(k) + "=" + encodeURIComponent(v));
                                    }
                            }
                        return str.join("&");
                    };
                return serialize(getters.vacancyFilter);

            }
    },
    actions    : {
        async loadVacancies( {
                                 commit,
                                 state,
                                 getters
                             } )
            {
                if( state.loading )
                    {
                        return "";
                    }
                commit("setLoadingState", true);

                try
                    {
                        commit("setMetroFilter", "");
                        commit("setDistrictFilter", "");
                        // let U  =new URLSearchParams(state.filter);
                        let url="/api/v2/vacancies/list/?" + getters.serializedFilter;

                        let fetchResult=await fetch(url);
                        let result     =await fetchResult.json();

                        if( result.success === false )
                            {
                                console.warn(result.error);
                                window.showHeaderMessage("Произошла ошибка загрузки", "error");
                                return "";
                            }
                        console.log(result);
                        commit("setVacancies", result.data.items);
                        commit("setLastExecutedFilter");
                        commit("setMapId");
                        commit("removeAddressFilter");
                        return result.data.url || "";
                    } catch( e )
                    {
                        window.showHeaderMessage("Непредвиденная ошибка загрузки", "error");
                        console.warn(e, "ошибка загрузки вакансий");
                        return "";
                    }
                finally
                    {
                        commit("setLoadingState", false);
                    }
            },
        async getCitiesWithMetro( {commit, state, getters} )
            {
                if(state.citiesWithMetro.length)
                    {
                        return;
                    }
                try
                    {
                        let url          ="/api/v2/info/cities-with-metro/";
                        const fetchResult=await fetch(url);
                        const result     =await fetchResult.json();
                        if( Array.isArray(result) && result.length > 0 )
                            {
                                commit("setCitiesWithMetro", result);
                            }
                        else
                            {
                                console.warn(result.error);
                            }
                    } catch( e )
                    {


                    }

            },
        dropFilter( {
                        state,
                        commit,
                        dispatch
                    } )
            {
                state.uniqueKey++;
                commit("setVacancyViewMode", "list");
                commit("setVacancies", []);
            },
        initMap( {state} )
            {
                return new Promise(resolve =>
                {
                    if( !window.ymaps )
                        {
                            let script   =document.createElement("script");
                            script.src   ="https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                            script.onload=() =>
                                {
                                    window.ymaps.ready(() =>
                                    {
                                        resolve(window.ymaps);
                                        state.mapInitialized=true;
                                    });
                                };
                            document.body.appendChild(script);
                        }
                    else
                        {
                            resolve(window.ymaps);
                        }
                });
            },
        mapSelectVacancy( {state}, addressId )
            {
                if( addressId )
                    {
                        state.view           ="list";
                        state.selectedAddress=addressId;
                    }
                else
                    {
                        state.selectedAddress=0;
                    }

            },
        mapSelectAddress( {state}, address )
            {
                if( address )
                    {
                        state.address=address;

                    }
                else
                    {
                        state.address="";
                    }
            },
        showOnMap( {
                       state,
                       commit,
                       getters
                   }, address )
            {
                if( address )
                    {
                        commit("setVacancyViewMode", "map");
                        commit("setSelectedAddress", address);
                        state.address=address;

                    }
                else
                    {
                        state.address="";
                    }

            }
    }
};
